import React from "react";
import {LangItem} from "../../core/Helpers/LangItem";

type Section = {
    eyebrow?: string;
    title: string;
    text: string;
    image: string;
    imageAlt?: string;
};

type Props = {
    sections: Section[];
};

class AboutProcessSection extends React.Component<Props> {
    renderSection(section: Section, index: number) {
        const isFlipped = index % 2 === 1;

        return (
            <div
                key={index}
                className={`process__row ${isFlipped ? "process__row--flip" : ""}`}
            >
                <div className="process__text">
                    {section.eyebrow && (
                        <div className="process__eyebrow wow-text-description">
                            <LangItem for={section.eyebrow} />
                        </div>
                    )}
                    <h2 className="process__title wow-text-title">
                        <LangItem for={section.title} />
                    </h2>
                    <p className="process__p wow-text-description">
                        <LangItem for={section.text} />
                    </p>
                </div>

                <div className="process__media">
                    <img
                        className="process__img"
                        src={section.image}
                        alt={section.imageAlt || section.title}
                    />
                </div>
            </div>
        );
    }

    render() {
        const { sections } = this.props;

        return (
            <section className="process">
                {sections.map((section, index) => this.renderSection(section, index))}
            </section>
        );
    }
}

export { AboutProcessSection };
